import React from 'react';

export default function Step4Vehicle({ formData, files, errors, updateField, updateFile, clearError }) {
  const h = (e) => { updateField(e.target.name, e.target.value); clearError(e.target.name); };
  const hf = (e) => { updateFile(e.target.name, e.target.files[0]); clearError(e.target.name); };
  const hfMulti = (e) => { updateFile(e.target.name, Array.from(e.target.files)); clearError(e.target.name); };
  const handleVehicleReg = (e) => {
    updateField('vehicle_reg', e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase().slice(0, 8));
    clearError('vehicle_reg');
  };
  const handleVehicleYear = (e) => {
    updateField('vehicle_year', e.target.value.replace(/[^0-9]/g, '').slice(0, 4));
    clearError('vehicle_year');
  };

  // MOT required for vehicles 3+ years old
  const currentYear = new Date().getFullYear();
  const vehicleYear = parseInt(formData.vehicle_year, 10);
  const vehicleAge = !isNaN(vehicleYear) && formData.vehicle_year?.trim().length === 4
    ? currentYear - vehicleYear
    : null;
  const needsMOT = vehicleAge !== null && vehicleAge >= 3;

  return (
    <div className="adi-step-content">
      <div className="adi-step-header">
        <span className="adi-step-num-badge">4</span>
        <div>
          <h2 className="adi-step-title">Vehicle Details &amp; Compliance</h2>
          <p className="adi-step-desc">Information about your teaching vehicle and required documents</p>
        </div>
      </div>

      <div className="adi-field-grid">

        <div className="adi-field">
          <label>Vehicle Make *</label>
          <input name="vehicle_make" value={formData.vehicle_make || ''} onChange={h}
            placeholder="e.g. Toyota"
            className={errors.vehicle_make ? 'err' : ''} />
          {errors.vehicle_make && <span className="adi-err">{errors.vehicle_make}</span>}
        </div>

        <div className="adi-field">
          <label>Vehicle Model *</label>
          <input name="vehicle_model" value={formData.vehicle_model || ''} onChange={h}
            placeholder="e.g. Corolla"
            className={errors.vehicle_model ? 'err' : ''} />
          {errors.vehicle_model && <span className="adi-err">{errors.vehicle_model}</span>}
        </div>

        <div className="adi-field">
          <label>Registration Number *</label>
          <input name="vehicle_reg" value={formData.vehicle_reg || ''} onChange={handleVehicleReg}
            placeholder="e.g. AB12 CDE"
            style={{ textTransform: 'uppercase', fontFamily: 'monospace', letterSpacing: '1px' }}
            maxLength={7}
            className={errors.vehicle_reg ? 'err' : ''} />
          {errors.vehicle_reg
            ? <span className="adi-err">{errors.vehicle_reg}</span>
            : <p className="adi-field-note">UK format: 2 letters · 2 digits · 3 letters (e.g. AB12 CDE)</p>
          }
        </div>

        <div className="adi-field">
          <label>Vehicle Year *</label>
          <input name="vehicle_year" value={formData.vehicle_year || ''} onChange={handleVehicleYear}
            placeholder={`e.g. ${new Date().getFullYear()}`}
            inputMode="numeric"
            maxLength={4}
            className={errors.vehicle_year ? 'err' : ''} />
          {errors.vehicle_year
            ? <span className="adi-err">{errors.vehicle_year}</span>
            : <p className="adi-field-note">4-digit year, 2000 – {new Date().getFullYear() + 1}</p>
          }
        </div>

        <div className="adi-field">
          <label>Vehicle Colour *</label>
          <input name="vehicle_colour" value={formData.vehicle_colour || ''} onChange={h}
            placeholder="e.g. Silver, Black, White"
            className={errors.vehicle_colour ? 'err' : ''} />
          {errors.vehicle_colour && <span className="adi-err">{errors.vehicle_colour}</span>}
        </div>

        <div className="adi-field">
          <label>Transmission *</label>
          <select name="transmission" value={formData.transmission || ''} onChange={h}
            className={errors.transmission ? 'err' : ''}>
            <option value="">Select transmission</option>
            <option value="manual">Manual</option>
            <option value="automatic">Automatic</option>
          </select>
          {errors.transmission && <span className="adi-err">{errors.transmission}</span>}
        </div>

      </div>

      {/* Document uploads */}
      <div className="adi-upload-section">
        <h3 className="adi-upload-section-title">Vehicle Documents</h3>

        <div className="adi-field-grid">

          <div className="adi-field adi-field--upload">
            <label>Motor Insurance Certificate *</label>
            {/* <p className="adi-upload-hint">Must cover driving instruction / hire &amp; reward use</p> */}
            <div className={`adi-upload-box${errors.insurance_doc ? ' adi-upload-box--err' : ''}`}>
              <input type="file" name="insurance_doc" onChange={hf} accept="image/*,.pdf" />
              <div className="adi-upload-label">
                {files.insurance_doc ? (
                  <span className="adi-upload-selected">✓ {files.insurance_doc.name}</span>
                ) : (
                  <><span className="adi-upload-icon">📄</span> Upload insurance certificate</>
                )}
              </div>
            </div>
            {errors.insurance_doc && <span className="adi-err">{errors.insurance_doc}</span>}
          </div>

          {/* MOT certificate — only shown (and required) when vehicle is 3+ years old */}
          {vehicleAge === null ? (
            <div className="adi-field adi-field--upload">
              <label style={{ color: '#94a3b8' }}>MOT Certificate <em>(enter vehicle year above first)</em></label>
              <div className="adi-upload-box" style={{ opacity: 0.5, pointerEvents: 'none' }}>
                <div className="adi-upload-label">
                  <span className="adi-upload-icon">📄</span> MOT certificate (if vehicle is 3+ years old)
                </div>
              </div>
              <p className="adi-field-note">Enter the vehicle year above — MOT is required for vehicles 3 or more years old</p>
            </div>
          ) : needsMOT ? (
            <div className="adi-field adi-field--upload">
              <label>MOT Certificate * <em style={{ fontWeight: 400, color: '#64748b' }}>({vehicleAge} years old — required)</em></label>
              <p className="adi-upload-hint">Your vehicle is {vehicleAge} year{vehicleAge !== 1 ? 's' : ''} old — a valid MOT is legally required</p>
              <div className={`adi-upload-box${errors.mot_doc ? ' adi-upload-box--err' : ''}`}>
                <input type="file" name="mot_doc" onChange={hf} accept="image/*,.pdf" />
                <div className="adi-upload-label">
                  {files.mot_doc ? (
                    <span className="adi-upload-selected">✓ {files.mot_doc.name}</span>
                  ) : (
                    <><span className="adi-upload-icon">📄</span> Upload MOT certificate</>
                  )}
                </div>
              </div>
              {errors.mot_doc && <span className="adi-err">{errors.mot_doc}</span>}
            </div>
          ) : (
            <div className="adi-field adi-field--upload">
              <label style={{ color: '#16a34a' }}>MOT Certificate <em style={{ fontWeight: 400 }}>(not required — vehicle is under 3 years old)</em></label>
              <div className="adi-upload-box" style={{ borderColor: '#86efac', background: '#f0fdf4' }}>
                <div className="adi-upload-label" style={{ color: '#16a34a' }}>
                  ✓ No MOT required for a {vehicleAge === 0 ? 'brand new' : vehicleAge + '-year-old'} vehicle
                </div>
              </div>
            </div>
          )}

          <div className="adi-field adi-field--upload adi-field--full">
            <label>Car Exterior Photos * <em>(front, back &amp; both sides)</em></label>
            <p className="adi-upload-hint">Upload multiple clear photos showing L-plates on the front and rear. Select all at once or add one at a time.</p>
            <div className={`adi-upload-box${errors.vehicle_exterior_photos ? ' adi-upload-box--err' : ''}`}>
              <input type="file" name="vehicle_exterior_photos" onChange={hfMulti} accept="image/*" multiple />
              <div className="adi-upload-label">
                {Array.isArray(files.vehicle_exterior_photos) && files.vehicle_exterior_photos.length > 0 ? (
                  <span className="adi-upload-selected">
                    ✓ {files.vehicle_exterior_photos.length} photo{files.vehicle_exterior_photos.length !== 1 ? 's' : ''} selected
                    <span className="adi-upload-filenames"> ({files.vehicle_exterior_photos.map(f => f.name).join(', ')})</span>
                  </span>
                ) : (
                  <><span className="adi-upload-icon"></span> Click to select or drag — multiple photos allowed</>
                )}
              </div>
            </div>
            {errors.vehicle_exterior_photos && <span className="adi-err">{errors.vehicle_exterior_photos}</span>}
          </div>

          <div className="adi-field adi-field--upload">
            <label>Car Interior Photos *</label>
            <p className="adi-upload-hint">Photos showing the front seats and rear seats clearly. Multiple photos allowed.</p>
            <div className={`adi-upload-box${errors.vehicle_interior_photos ? ' adi-upload-box--err' : ''}`}>
              <input type="file" name="vehicle_interior_photos" onChange={hfMulti} accept="image/*" multiple />
              <div className="adi-upload-label">
                {Array.isArray(files.vehicle_interior_photos) && files.vehicle_interior_photos.length > 0 ? (
                  <span className="adi-upload-selected">
                    ✓ {files.vehicle_interior_photos.length} photo{files.vehicle_interior_photos.length !== 1 ? 's' : ''} selected
                  </span>
                ) : (
                  <><span className="adi-upload-icon"></span> Click to select — multiple photos allowed</>
                )}
              </div>
            </div>
            {errors.vehicle_interior_photos && <span className="adi-err">{errors.vehicle_interior_photos}</span>}
          </div>

          <div className="adi-field adi-field--upload">
            <label>Dual Controls Photos *</label>
            <p className="adi-upload-hint">Photos clearly showing the fitted dual pedals / dual controls. Multiple photos allowed.</p>
            <div className={`adi-upload-box${errors.dual_controls_photos ? ' adi-upload-box--err' : ''}`}>
              <input type="file" name="dual_controls_photos" onChange={hfMulti} accept="image/*" multiple />
              <div className="adi-upload-label">
                {Array.isArray(files.dual_controls_photos) && files.dual_controls_photos.length > 0 ? (
                  <span className="adi-upload-selected">
                    ✓ {files.dual_controls_photos.length} photo{files.dual_controls_photos.length !== 1 ? 's' : ''} selected
                  </span>
                ) : (
                  <><span className="adi-upload-icon"></span> Click to select — multiple photos allowed</>
                )}
              </div>
            </div>
            {errors.dual_controls_photos && <span className="adi-err">{errors.dual_controls_photos}</span>}
          </div>

        </div>
      </div>
    </div>
  );
}
